export default "__VITE_ASSET__c78f250f__"